import { CenterCourse } from '../../../lib/types/models/center-course/center-course'
import { CenterCourseInput } from '../../../lib/types/models/center-course/center-course-input'
import { UpdateInput } from '../../../lib/types/utils'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const updateCenterCourse = async (
  data: UpdateInput<CenterCourseInput> & { centerId: number }
) => {
  const { id, centerId, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.centers.updateCenterCourse.url, { centerId, courseId: id }))
    .patch<CenterCourse, Partial<CenterCourseInput>>(rest)
}
